import script from "./investReviewedDetail.vue?vue&type=script&lang=ts&setup=true"
export * from "./investReviewedDetail.vue?vue&type=script&lang=ts&setup=true"

import "./investReviewedDetail.vue?vue&type=style&index=0&id=99b2a534&lang=less"

const __exports__ = script;

export default __exports__